import AbstractView from "../../../../../shared/src/ranj/equalture/view/AbstractView";

export default class ProgressDotsView extends AbstractView {

    constructor(target, total, rtl = false) {
        super(target);

        this._rtl = rtl;
        this._total = total;

        this._dots = [];
        for (let i = 0; i < 99; i++) {
            const dot = this._target["dot" + i];
            if (!dot) {
                break;
            }
            dot.xOrig = dot.x;
            this._dots.push(dot);
        }
        this._dx = this._dots[1].x - this._dots[2].x;

        this._index = 0;
        this.setTotal(total);
    }

    setTotal(total) {
        this._activeDots = [];
        const firstActive = Math.floor(this._dots.length - total) / 2;
        const offset = total % 2 != this._dots.length % 2 ? -this._dx / 2 : 0;

        this._dots.forEach((dot, idx) => {
            dot.visible = idx >= firstActive && idx < firstActive + total;
            if (dot.visible) {
                this._activeDots.push(dot);
            }
            dot.x = dot.xOrig + offset;
            this.setProgress(this._index);
        });
    }

    setProgress(index) {
        const dotIndex = this._rtl ? (this._activeDots.length - 1 - index) : index;
        this._activeDots.forEach((dot, idx) => {
            if (idx==dotIndex) {
                dot.gotoAndPlay("selected");
            } else {
                dot.gotoAndStop("unselected");
            }
        });
        this._index = index;
    }
};
